import React, { useEffect, useState } from 'react';
import Layout from '../../Layout';
import { Input, Table, notification, Switch } from 'antd';
import type { TableColumnsType, TableProps } from 'antd';
import { mixGetV2, mixPostV2 } from '../../services/mixin'
import useToast from "../../hook/useToast";
import BreadcrumbBlock from '../../components/BreadcrumbBlock/BreadcrumbBlock';

import {
  EyeOutlined, EditOutlined,
  // DeleteOutlined,
  // CopyOutlined,
  DownOutlined,
  CloseCircleOutlined,
  // UserAddOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import type { SearchProps } from 'antd/es/input/Search';
// import viVN from 'antd/locale/vi_VN';
import { Link } from 'react-router-dom';
import './PoolingDataSetupUpdate.scss'
import ListKeoTha from './ListKeoTha'
// import PopupShowData from './ComponentPoolingData/PopupShowData';
import ShowParam from './ShowParam';
// import ModalParamCreate from './Modal/ModalParamCreate';
import ModalParamEdit from './Modal/ModalParamEdit';
import CreateSystemParamModal from '../../components/SyncData/CreateSystemParamModalV2';

interface DataType {
  key: React.Key
}

const { Search } = Input;

const PoolingDataSetup: React.FC = () => {
  useEffect(() => {
    document.title = 'THACO AUTO CRM';
  }, []);

  const pushToast = useToast();

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const [isShowData, setShowData] = useState(false);
  const [isShowParam, setShowParam] = useState(false)
  // const [openParamCreate, setOpenParamCreate] = useState(false)
  const [openParamEdit, setOpenParamEdit] = useState(false)

  const [showSelectFilter, setActive] = useState(false);
  const [showSelectFilterShow, setActiveShow] = useState(false);
  const handleClearFilter = () => {
    setActive(false)
    setActiveShow(false)
  }

  const [showParamModal, setShowParamModal] = useState(false)

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (event.target.matches('.filter-select, .filter-select *, .list-filter, .list-filter *') === false) {
        setActive(false)
        setActiveShow(false)
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const columns: TableColumnsType<DataType> = [
    {
      title: 'Hành động',
      dataIndex: '',
      align: 'center',
      key: 'action',
      render: (_, row) => (
        <>
          <div className="t-hd-table">
            <div className="item-hd-table" onClick={() => { setShowParam(true); setEditData(row) }}><span><EyeOutlined /></span></div>
            <div className="item-hd-table cl-1890FF" onClick={() => { setOpenParamEdit(true); setEditData(row) }}><span><EditOutlined /></span></div>
            {/* <div className="item-hd-table cl-1890FF"><span><CopyOutlined /></span></div> */}
          </div>
        </>
      ),
    },
    {
      title: 'Tên Param',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
    },
    // {
    //   title: 'param key',
    //   dataIndex: 'column_warehouse',
    //   key: 'column_warehouse',
    //   render: (text: any, row: any) => (
    //     <div>
    //       {row.column_warehouse.column}
    //     </div>
    //   ),
    // },
    {
      title: 'Ghi chú',
      dataIndex: 'note',
      align: 'center',
      key: 'note'
    },
    {
      title: 'Hệ thống',
      dataIndex: 'hethong',
      align: 'center',
      render: (text: any, row: any) => (
        <>
          <div className="t-table-list-tags">
            {row.params_key.map((val: any) => (
              <div className="item-tag">{val.name}</div>
            ))}
          </div>
        </>
      ),
    },
    {
      title: 'Gợi ý hiển thị',
      dataIndex: 'date',
      align: 'right',
      render: (_, row: any) => (
        <>
          <Switch
            loading={waits[`id${row.id}`]}
            checked={row.is_default === 1}
            onChange={(e) => { defaultChange(e, row) }}
            className="rs-switch rs-switch--sm"
          />
        </>
      ),
    },
    {
      title: 'Trạng thái',
      dataIndex: 'date',
      align: 'right',
      render: (_, row: any) => (
        <>
          <Switch
            loading={waits[`id${row.id}`]}
            checked={row.is_active === 1}
            onChange={(e) => { activeChange(e, row) }}
            className="rs-switch rs-switch--sm"
          />
        </>
      ),
    },
  ];

  const [waits, setWaits] = useState({} as any)
  const activeChange = async (e: any, item: any) => {
    // const temp = item
    // if (e === true) {
    //   temp.is_active = 1
    // } else {
    //   temp.is_active = 0
    // }

    const param = {
      is_active: item.is_active === 0 ? 1 : 0,
      _method: 'PUT',
    }

    let wait = {} as any
    wait[`id${item.id}`] = true
    setWaits({ ...waits, ...wait })

    const res = await mixPostV2(`/api/v1/be/source_column_warehouse/${item.id}`, param)
    if (res.status) {
      wait[`id${item.id}`] = false
      setWaits({ ...waits, ...wait })

      const findData = listData.find((x: any) => x.id === item.id) as any
      if (findData) {
        findData.is_active = param.is_active
      }
      setListData([...listData])
    } else {
      pushToast("Error!", "warning")
    }
  }

  const defaultChange = async (e: any, item: any) => {
    const param = {
      is_default: item.is_default === 0 ? 1 : 0,
      _method: 'PUT',
    }

    let wait = {} as any
    wait[`id${item.id}`] = true
    setWaits({ ...waits, ...wait })

    const res = await mixPostV2(`/api/v1/be/source_column_warehouse/${item.id}`, param)
    if (res.status) {
      wait[`id${item.id}`] = false
      setWaits({ ...waits, ...wait })

      const findData = listData.find((x: any) => x.id === item.id) as any
      if (findData) {
        findData.is_default = param.is_default
      }
      setListData([...listData])
    } else {
      pushToast("Error!", "warning")
    }
  }

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  // const rowSelection = {
  //   selectedRowKeys,
  //   onChange: onSelectChange,
  // };

  const onChangeTB: TableProps<DataType>['onChange'] = (pagination, filters, sorter, extra) => {
    console.log('params', pagination, filters, sorter, extra);
  };

  const setShowNoti = () => {
    setShowData(false)
    openNotification()
  };

  // NOTIFICATION
  const [api, contextHolder] = notification.useNotification();
  const openNotification = () => {
    api['success']({
      message: 'Tạo Voucher thành công!',
      placement: 'bottomRight',
      className: 'single-message'
    });
  };

  const onSearch: SearchProps['onSearch'] = (value, _e, info) => {
    setParamListData({ ...paramListData, name: value })
  }

  const [paramListData, setParamListData] = useState({
    'sort[]': 'is_active,desc',
    page: 1,
    limit: 100000,
    name: '',
    source_id: null,
  } as any)
  let wait = false
  const [listData, setListData] = useState([])
  const getListData = async () => {
    if (wait) {
      return
    }
    wait = true
    const res = await mixGetV2('/api/v1/be/source_column_warehouses', paramListData)
    if (res.status) {
      setListData(res.data.items)
    }
  }

  useEffect(() => {
    getListData()
  }, [paramListData])

  const [listSource, setListSource] = useState([] as any)
  let wait1 = false
  const getSource = async () => {
    if (wait1) {
      return
    }
    wait1 = true
    const res = await mixGetV2('/api/v1/be/sources')
    wait1 = false
    if (res.status) {
      const temp = [] as any
      res.data.items.map((val: any) => {
        temp.push({
          value: val.id,
          label: val.name,
        })
        return true
      })
      setListSource([...temp])
    }
  }

  useEffect(() => {
    getSource()
  }, [])

  const [editData, setEditData] = useState(null as any)
  const [ftlabel, setFtlabel] = useState('Chọn hệ thống')
  const [ftlabelShow, setFtlabelShow] = useState('Phạm vi hiển thị')

  let wait2 = false
  const [source, setSource] = useState([] as any)
  const getSourceV2 = async () => {
    if (wait2) {
      return
    }
    wait2 = true
    const res = await mixGetV2('/api/v1/be/sources')
    wait2 = false
    if (res.status) {
      setSource([...res.data.items])
    }
  }
  useEffect(() => {
    getSourceV2()
  }, [])
  return (
    <div className='pooling-data-auto-detail customer-list'>
      {contextHolder}
      {/* <Helmet>
        <title>THACO AUTO CRM</title>
      </Helmet> */}
      <Layout>
        <BreadcrumbBlock
          items={[
            { title: <Link to="/">THACO AUTO CRM</Link>, },
            { title: 'Khách hàng', },
            { title: <Link to="/customer/pooling-data">Gộp dữ liệu khách hàng</Link>, },
            { title: 'Cài đặt param hệ thống', },
          ]}
          title='Cài đặt param hệ thống update'
          backLink='/customer/pooling-data'
          className='gutter-block-end'
        />

        {/* Fillter block */}
        <div className='filter-block t-mb-18'>
          <div className='t-search-block w-100'>
            <Search placeholder="Tìm kiếm số tên param, hoặc mã param" onSearch={onSearch} />
          </div>

          <div className='filter-select'>
            <div
              className='btn-select-show'
            >
              <span className="content-select" onClick={() => setActive(true)} >{ftlabel}</span>
              <div
                className={`icon-down ${showSelectFilter ? "active" : ""}`}
                onClick={() => setActive(true)}
              >
                <DownOutlined />
              </div>
              <div
                className={`icon-close ${showSelectFilter && ftlabel !== 'Chọn hệ thống' ? "active" : ""}`}
                onClick={() => { handleClearFilter(); setFtlabel('Chọn hệ thống'); setParamListData({ ...paramListData, source_id: null }) }}
              >
                <CloseCircleOutlined />
              </div>
            </div>
            <div className={`list-filter ${showSelectFilter ? "active" : ""}`}>
              <div className="list-item">
                {
                  listSource.map((val: any) => (
                    <div key={val.value} className="item-select" onClick={() => { handleClearFilter(); setFtlabel(val.label); setParamListData({ ...paramListData, source_id: val.value }) }} >{val.label}</div>
                  ))
                }
              </div>
            </div>
          </div>

          <div className='filter-select'>
            <div
              className='btn-select-show'
            >
              <span className="content-select" onClick={() => setActiveShow(true)} >{ftlabelShow}</span>
              <div
                className={`icon-down ${showSelectFilterShow ? "active" : ""}`}
                onClick={() => setActiveShow(true)}
              >
                <DownOutlined />
              </div>
              <div
                className={`icon-close ${showSelectFilterShow && ftlabelShow !== 'Phạm vi hiển thị' ? "active" : ""}`}
                onClick={() => { handleClearFilter(); setFtlabelShow('Phạm vi hiển thị'); setParamListData({ ...paramListData, source_id: null }) }}
              >
                <CloseCircleOutlined />
              </div>
            </div>
            <div className={`list-filter ${showSelectFilterShow ? "active" : ""}`}>
              <div className="list-item">
                {
                  listSource.map((val: any) => (
                    <div key={val.value} className="item-select" onClick={() => { handleClearFilter(); setFtlabel(val.label); setParamListData({ ...paramListData, source_id: val.value }) }} >{val.label}</div>
                  ))
                }
              </div>
            </div>
          </div>

          <div
            className="btn-input"
          >
            <div className="text">Quản lý điều kiện ưu tiên</div>
          </div>

          <div
            className="icon-list flex items-center justify-center text-24 cursor-pointer"
          >
            <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22.7151 3.43025H7.07227C6.95441 3.43025 6.85798 3.52667 6.85798 3.64453V5.14453C6.85798 5.26239 6.95441 5.35882 7.07227 5.35882H22.7151C22.833 5.35882 22.9294 5.26239 22.9294 5.14453V3.64453C22.9294 3.52667 22.833 3.43025 22.7151 3.43025ZM22.7151 11.0374H7.07227C6.95441 11.0374 6.85798 11.1338 6.85798 11.2517V12.7517C6.85798 12.8695 6.95441 12.966 7.07227 12.966H22.7151C22.833 12.966 22.9294 12.8695 22.9294 12.7517V11.2517C22.9294 11.1338 22.833 11.0374 22.7151 11.0374ZM22.7151 18.6445H7.07227C6.95441 18.6445 6.85798 18.741 6.85798 18.8588V20.3588C6.85798 20.4767 6.95441 20.5731 7.07227 20.5731H22.7151C22.833 20.5731 22.9294 20.4767 22.9294 20.3588V18.8588C22.9294 18.741 22.833 18.6445 22.7151 18.6445ZM1.07227 4.39453C1.07227 4.59151 1.11106 4.78657 1.18645 4.96856C1.26183 5.15054 1.37232 5.3159 1.51161 5.45519C1.65089 5.59448 1.81625 5.70497 1.99824 5.78035C2.18023 5.85573 2.37528 5.89453 2.57227 5.89453C2.76925 5.89453 2.9643 5.85573 3.14629 5.78035C3.32828 5.70497 3.49364 5.59448 3.63293 5.45519C3.77221 5.3159 3.8827 5.15054 3.95809 4.96856C4.03347 4.78657 4.07227 4.59151 4.07227 4.39453C4.07227 4.19755 4.03347 4.00249 3.95809 3.82051C3.8827 3.63852 3.77221 3.47316 3.63293 3.33387C3.49364 3.19458 3.32828 3.08409 3.14629 3.00871C2.9643 2.93333 2.76925 2.89453 2.57227 2.89453C2.37528 2.89453 2.18023 2.93333 1.99824 3.00871C1.81625 3.08409 1.65089 3.19458 1.51161 3.33387C1.37232 3.47316 1.26183 3.63852 1.18645 3.82051C1.11106 4.00249 1.07227 4.19755 1.07227 4.39453ZM1.07227 12.0017C1.07227 12.1987 1.11106 12.3937 1.18645 12.5757C1.26183 12.7577 1.37232 12.923 1.51161 13.0623C1.65089 13.2016 1.81625 13.3121 1.99824 13.3875C2.18023 13.4629 2.37528 13.5017 2.57227 13.5017C2.76925 13.5017 2.9643 13.4629 3.14629 13.3875C3.32828 13.3121 3.49364 13.2016 3.63293 13.0623C3.77221 12.923 3.8827 12.7577 3.95809 12.5757C4.03347 12.3937 4.07227 12.1987 4.07227 12.0017C4.07227 11.8047 4.03347 11.6096 3.95809 11.4276C3.8827 11.2457 3.77221 11.0803 3.63293 10.941C3.49364 10.8017 3.32828 10.6912 3.14629 10.6159C2.9643 10.5405 2.76925 10.5017 2.57227 10.5017C2.37528 10.5017 2.18023 10.5405 1.99824 10.6159C1.81625 10.6912 1.65089 10.8017 1.51161 10.941C1.37232 11.0803 1.26183 11.2457 1.18645 11.4276C1.11106 11.6096 1.07227 11.8047 1.07227 12.0017ZM1.07227 19.6088C1.07227 19.8058 1.11106 20.0009 1.18645 20.1828C1.26183 20.3648 1.37232 20.5302 1.51161 20.6695C1.65089 20.8088 1.81625 20.9193 1.99824 20.9946C2.18023 21.07 2.37528 21.1088 2.57227 21.1088C2.76925 21.1088 2.9643 21.07 3.14629 20.9946C3.32828 20.9193 3.49364 20.8088 3.63293 20.6695C3.77221 20.5302 3.8827 20.3648 3.95809 20.1828C4.03347 20.0009 4.07227 19.8058 4.07227 19.6088C4.07227 19.4118 4.03347 19.2168 3.95809 19.0348C3.8827 18.8528 3.77221 18.6874 3.63293 18.5482C3.49364 18.4089 3.32828 18.2984 3.14629 18.223C2.9643 18.1476 2.76925 18.1088 2.57227 18.1088C2.37528 18.1088 2.18023 18.1476 1.99824 18.223C1.81625 18.2984 1.65089 18.4089 1.51161 18.5482C1.37232 18.6874 1.26183 18.8528 1.18645 19.0348C1.11106 19.2168 1.07227 19.4118 1.07227 19.6088Z" fill="#98A2B3" />
            </svg>
          </div>

          <div className="line-1-16-E1E1E1"></div>

          <div
            className="icon-list flex items-center justify-center text-24 cursor-pointer"
          >
            <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.2812 15H18.8438V11.4375C18.8438 11.3344 18.7594 11.25 18.6562 11.25H12.8438V9H15.375C15.5813 9 15.75 8.83125 15.75 8.625V1.875C15.75 1.66875 15.5813 1.5 15.375 1.5H8.625C8.41875 1.5 8.25 1.66875 8.25 1.875V8.625C8.25 8.83125 8.41875 9 8.625 9H11.1562V11.25H5.34375C5.24062 11.25 5.15625 11.3344 5.15625 11.4375V15H2.71875C2.5125 15 2.34375 15.1687 2.34375 15.375V22.125C2.34375 22.3312 2.5125 22.5 2.71875 22.5H9.46875C9.675 22.5 9.84375 22.3312 9.84375 22.125V15.375C9.84375 15.1687 9.675 15 9.46875 15H6.84375V12.9375H17.1562V15H14.5312C14.325 15 14.1562 15.1687 14.1562 15.375V22.125C14.1562 22.3312 14.325 22.5 14.5312 22.5H21.2812C21.4875 22.5 21.6562 22.3312 21.6562 22.125V15.375C21.6562 15.1687 21.4875 15 21.2812 15ZM8.0625 16.7812V20.7188H4.125V16.7812H8.0625ZM10.0312 7.21875V3.28125H13.9688V7.21875H10.0312ZM19.875 20.7188H15.9375V16.7812H19.875V20.7188Z" fill="#1890FF" />
            </svg>
          </div>

          <div
            className="btn-input btn-primary"
            onClick={() => setShowParamModal(true)}
          >
            <div className="icon-svg">
              <PlusOutlined />
            </div>
            <div className="text">Tạo mới</div>
          </div>
        </div>

        <div className="header-16-24-8-8-096DD9-16">Cấu trúc param theo hệ thống</div>
        <ListKeoTha />
      </Layout>
    </div>
  );
}

export default PoolingDataSetup;
